import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Headline from '#components/a/Headline'
import ArrowLeft from '#components/svg/icons/ArrowLeft'
import Text from '#components/a/Text'

function AzubiProfile({user, onClick}) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyPress={onClick}
      className="azubiprofile"
      data-testid="azubiprofile">
      <div>
        <Headline importance={3} modifier="category" text={`${user.lastname}, ${user.firstname}`} />
        <ArrowLeft />
      </div>
      <Text modifier="small" text={user.ausbildungsBerufString} />
    </div>
  )
}

AzubiProfile.propTypes = {
  user: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    ausbildungsBerufString: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
}

export default AzubiProfile
